import type {
  CreateSupplierPayload,
  SupplierListRow,
  UpdateSupplierPayload,
} from "@/modules/inventory/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type SuppliersListParams = {
  search?: string;
  isActive?: boolean;
};

export const inventorySuppliersApi = {
  async list(params: SuppliersListParams = {}): Promise<SupplierListRow[]> {
    const searchParams = new URLSearchParams();
    if (params.search?.trim()) {
      searchParams.set("search", params.search.trim());
    }
    if (params.isActive !== undefined) {
      searchParams.set("isActive", params.isActive ? "true" : "false");
    }
    const qs = searchParams.toString();
    return fetcher.get<SupplierListRow[]>(
      `${config.apiUrl}/inventory/suppliers${qs ? `?${qs}` : ""}`,
    );
  },

  async lookup(): Promise<SupplierListRow[]> {
    return fetcher.get<SupplierListRow[]>(
      `${config.apiUrl}/inventory/suppliers/lookup`,
    );
  },

  async get(id: string): Promise<SupplierListRow> {
    return fetcher.get<SupplierListRow>(
      `${config.apiUrl}/inventory/suppliers/${id}`,
    );
  },

  async create(payload: CreateSupplierPayload): Promise<SupplierListRow> {
    return fetcher.post<SupplierListRow>(
      `${config.apiUrl}/inventory/suppliers`,
      payload,
    );
  },

  async update(
    id: string,
    payload: UpdateSupplierPayload,
  ): Promise<SupplierListRow> {
    return fetcher.patch<SupplierListRow>(
      `${config.apiUrl}/inventory/suppliers/${id}`,
      payload,
    );
  },

  async deactivate(id: string): Promise<SupplierListRow> {
    return fetcher.delete<SupplierListRow>(
      `${config.apiUrl}/inventory/suppliers/${id}`,
    );
  },
};

export function formatSupplierApiError(e: unknown): string {
  const msg = (e as Error)?.message;
  if (msg === "DUPLICATE_SUPPLIER_CODE") {
    return "ລະຫັດຜູ້ສະໜອງນີ້ມີແລ້ວ";
  }
  if (msg === "NOT_FOUND") {
    return "ບໍ່ພົບຜູ້ສະໜອງ";
  }
  return msg ?? "ຄໍາຮ້ອງຂໍລົ້ມເຫຼວ";
}
